import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@trashlab/sitesapp/src/routes/__root';
import { HomeHeroSection } from '@trashlab/sitesapp/src/organizations/_default/template/components/home/home-hero-section';
import { FAQ } from '@trashlab/sitesapp/src/organizations/_default/template/components/shared/faq-section';
import { Testimonials } from '@trashlab/sitesapp/src/organizations/_default/template/components/shared/testimonials-section';
import { WhyChooseUs } from '@trashlab/sitesapp/src/organizations/_default/template/components/home/why-choose-us';
import { CompanyStats } from '@trashlab/sitesapp/src/organizations/_default/template/components/home/company-stats';
import { CtaSection } from '@trashlab/sitesapp/src/organizations/_default/template/components/shared/cta-section';
import { DumpsterTypes } from '@trashlab/sitesapp/src/organizations/_default/template/components/dumpster-rentals/dumpster-types';
import { BestDealReasons } from '@trashlab/sitesapp/src/organizations/_default/template/components/home/best-deal-reasons';
import { useTenantContext } from '@trashlab/sitesapp/src/organizations/_default/contexts/use-tenant-context';
import { useEffect } from 'react';
import { useLocation } from '@tanstack/react-router';
import { WebsiteSchema } from '@trashlab/sitesapp/src/organizations/_default/components/seo/schemas/website-schema';
import { useVariantValue } from '@trashlab/sitesapp/src/organizations/_default/lib/utils/get-variant-value';

// Best Deal Dumpsters org ID
const BEST_DEAL_ORG_ID = 'd74bb19c-004b-479d-adaa-9e846d25dac7';

const HomePage = () => {
  const location = useLocation();
  const { website } = useTenantContext();

  const isBestDeal = website?.organization?.id === BEST_DEAL_ORG_ID;

  // Get SEO values for WebsiteSchema
  const seoDescription = useVariantValue(
    'SEO_DESCRIPTION',
    'Professional dumpster rental services with same-day delivery. Competitive rates, flexible rental periods, and expert waste management for residential and commercial projects.'
  );

  // Website URL for schema
  const baseUrl = typeof window !== 'undefined' ? window.location.origin : '';
  const siteName = website?.organization?.name
    ? website.organization.name
    : 'Dumpster Rental Services';

  useEffect(() => {
    // Check if the URL has a hash and scroll to that element
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  // Best Deal gets dumpster cards instead of "Why Choose Us" section
  if (isBestDeal) {
    return (
      <>
        {/* WebsiteSchema for home page - enables sitelinks searchbox in Google */}
        <WebsiteSchema
          name={siteName}
          url={baseUrl}
          description={seoDescription}
        />
        <HomeHeroSection />
        <DumpsterTypes defaultType="rolloff" />
        <CompanyStats withBackground />
        <BestDealReasons />
        <Testimonials withBackground />
        <FAQ faqType="home" />
        <CtaSection withBackground />
      </>
    );
  }

  return (
    <>
      {/* WebsiteSchema for home page - enables sitelinks searchbox in Google */}
      <WebsiteSchema
        name={siteName}
        url={baseUrl}
        description={seoDescription}
      />
      <HomeHeroSection />
      <WhyChooseUs />
      <CompanyStats />
      <Testimonials withBackground />
      <FAQ faqType="home" />
      <CtaSection withBackground />
    </>
  );
};

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: HomePage,
});
